var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-nav-check',{staticClass:"sky__icon",class:'text-' + _vm.color})
}
var staticRenderFns = []

export { render, staticRenderFns }